import React from "react";
import { useTheme } from "@emotion/react";

const CcButton = ({ type = "button", label, isActive = false, fullWidth = true, onClick, ...props }) => {
  const theme = useTheme();

  const intervalBtnStyle = (isActive, fullWidth) => ({
    backgroundColor: isActive ? theme.colors.primary : theme.colors.white,
    border: `1px solid ${theme.colors.primary}`,
    borderRadius: 3,
    boxShadow: "0px 1px 5px rgba(0,0,0,0.2)",
    boxSizing: "border-box",
    color: isActive ? theme.colors.white : theme.colors.font,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 30,
    width: fullWidth ? "100%" : "auto",
    padding: "3px 10px",
    transition: "all .2s ease-in-out",
    "&:hover": {
      backgroundColor: isActive ? theme.colors.white : theme.colors.primary,
      color: isActive ? theme.colors.primary : theme.colors.white,
    },
  });

  return(
    <button
      type={type}
      onClick={onClick}
      css={intervalBtnStyle(isActive, fullWidth)}
      {...props}
    >
      {label}
    </button>
  );
};

export default CcButton;
